import { combineReducers } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import loadingReducer from './slices/loadingSlice';
import waterChangeStandardReducer from './slices/waterChangeStandardSlice';
import organizationReducer from './slices/organizationSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  loading: loadingReducer,
  waterChangeStandard: waterChangeStandardReducer,
  organization: organizationReducer,
});

export default rootReducer;
